<template>
  <v-dialog :model-value="dialog" @update:model-value="updateDialog" max-width="600px" persistent>
    <!-- ❌ PROBLEMA: @input debería ser @update:model-value -->
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <!-- Campo para el DNI -->
            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.numero_documento" label="Número de Documento"
                append-icon="mdi-magnify" @click:append="buscarPorDni" @keyup.enter="buscarPorDni"
                :rules="[rules.required]"></v-text-field>
            </v-col>

            <!-- Resto de campos igual... -->
            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.nombres" label="Nombres" :disabled="!camposHabilitados"
                :rules="[rules.required]"></v-text-field>
            </v-col>
            <!-- ... más campos ... -->

            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.apellido_paterno" label="Apellido Paterno"
                :disabled="!camposHabilitados" :rules="[rules.required]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.apellido_materno" label="Apellido Materno"
                :disabled="!camposHabilitados" :rules="[rules.required]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select v-model="localEditedItem.tipo_documento_id" :items="tipoDocumentos" label="Tipo de Documento"
                :disabled="!camposHabilitados" :rules="[rules.required]"></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.fecha_nacimiento" label="Fecha de Nacimiento" type="date"
                :disabled="!camposHabilitados" :rules="[rules.required]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.celular" label="Celular" :disabled="!camposHabilitados"
                :rules="[rules.required, rules.phone]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.email" label="Email" :disabled="!camposHabilitados"
                :rules="[rules.email]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.direccion" label="Dirección"
                :disabled="!camposHabilitados"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="localEditedItem.ruta_foto" label="Ruta de Foto"
                :disabled="!camposHabilitados"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select v-model="localEditedItem.genero_id" :items="generos" label="Género" item-title="descripcion"
                item-value="id" :disabled="!camposHabilitados" :rules="[rules.required]"></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" variant="text" @click="close">
          Cancelar
        </v-btn>
        <v-btn color="primary" variant="text" @click="save" :disabled="!camposHabilitados || !isFormValid">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    dialog: Boolean,
    editedItem: {
      type: Object,
      default: () => ({}) // ❌ PROBLEMA: Falta default factory
    },
    formTitle: String,
  },

  emits: ['update:dialog', 'close', 'saved'],

  data() {
    return {
      camposHabilitados: false,
      localEditedItem: {
        numero_documento: '',
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        tipo_documento_id: 1,
        fecha_nacimiento: '',
        celular: '',
        email: '',
        direccion: '',
        ruta_foto: '',
        genero_id: '',
        // Combinar con editedItem
        ...this.editedItem
      },
      tipoDocumentos: [
        { title: 'DNI', value: 1 },
        { title: 'PASAPORTE', value: 2 },
        { title: 'CARNET DE EXTRANJERIA', value: 3 },
      ],
      rules: {
        required: (value) => !!value || 'Este campo es obligatorio',
        email: (value) =>
          !value || /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(value) || 'Email inválido',
        phone: (value) =>
          !value || /^[0-9]{9}$/.test(value) || 'Debe ser un número de teléfono válido',
      },
    };
  },

  computed: {
    ...mapGetters('alumno', ['generos']),
    isFormValid() {
      return (
        this.localEditedItem.numero_documento &&
        this.localEditedItem.nombres &&
        this.localEditedItem.apellido_paterno &&
        this.localEditedItem.apellido_materno &&
        this.localEditedItem.tipo_documento_id &&
        this.localEditedItem.fecha_nacimiento &&
        this.localEditedItem.celular &&
        this.localEditedItem.genero_id
      );
    },
  },

  // ❌ PROBLEMA: Falta watcher para editedItem
  watch: {
    editedItem: {
      handler(newVal) {
        this.localEditedItem = {
          numero_documento: '',
          nombres: '',
          apellido_paterno: '',
          apellido_materno: '',
          tipo_documento_id: 1,
          fecha_nacimiento: '',
          celular: '',
          email: '',
          direccion: '',
          ruta_foto: '',
          genero_id: '',
          ...newVal
        };
      },
      deep: true,
      immediate: true
    },
    dialog(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    }
  },

  methods: {
    ...mapActions('alumno', ['createAlumno', 'saveAlumno', 'buscarAlumnoPorDni', 'fetchGeneros']),

    updateDialog(value) {
      this.$emit('update:dialog', value);
    },

    close() {
      this.$emit('close');
      this.$emit('update:dialog', false);
    },

    resetForm() {
      this.localEditedItem = {
        numero_documento: '',
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        tipo_documento_id: 1,
        fecha_nacimiento: '',
        celular: '',
        email: '',
        direccion: '',
        ruta_foto: '',
        genero_id: '',
      };
      this.camposHabilitados = false;
    },

    async save() {
      if (!this.isFormValid) {
        console.warn('Formulario inválido.');
        return;
      }

      try {
        if (this.localEditedItem.id) {
          await this.saveAlumno(this.localEditedItem);
        } else {
          await this.createAlumno(this.localEditedItem);
        }
        this.$emit('saved');
        this.resetForm();
        this.close();
      } catch (error) {
        console.error('Error guardando alumno:', error);
      }
    },

    async buscarPorDni() {
      if (!this.localEditedItem.numero_documento) return;

      try {
        const response = await this.buscarAlumnoPorDni(this.localEditedItem.numero_documento);
        if (response.success) {
          this.localEditedItem.nombres = response.data.nombre || '';
          this.localEditedItem.apellido_paterno = response.data.apellido_paterno || '';
          this.localEditedItem.apellido_materno = response.data.apellido_materno || '';
          this.localEditedItem.fecha_nacimiento = response.data.fecha_nacimiento?.replace(/\//g, '-') || '';
          this.localEditedItem.genero_id = response.data.sexo ? parseInt(response.data.sexo) : '';
          this.camposHabilitados = true;
        } else {
          console.warn('No se encontraron datos para este DNI.');
          this.camposHabilitados = true; // Permitir edición manual
        }
      } catch (error) {
        console.error('Error buscando por DNI:', error);
        this.camposHabilitados = true;
      }
    },
  },

  async mounted() {
    await this.fetchGeneros();
  },
};
</script>